/**
 * Map a free-text country (as stored on hr.employees / imported from the CSV)
 * to a flag emoji + an accessible label. Returns null when the country can't be
 * resolved, so callers can fall back to plain text.
 */

const ALIASES: Record<string, string> = {
  uk: 'GB',
  'united kingdom': 'GB',
  'great britain': 'GB',
  britain: 'GB',
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  gb: 'GB',
  usa: 'US',
  'u.s.a.': 'US',
  'united states': 'US',
  'united states of america': 'US',
  america: 'US',
  us: 'US',
  canada: 'CA',
  ca: 'CA',
  australia: 'AU',
  au: 'AU',
  india: 'IN',
  in: 'IN',
  japan: 'JP',
  jp: 'JP',
  ireland: 'IE',
  germany: 'DE',
  france: 'FR',
  spain: 'ES',
  italy: 'IT',
  netherlands: 'NL',
  'new zealand': 'NZ',
  mexico: 'MX',
  brazil: 'BR',
  'south africa': 'ZA',
  singapore: 'SG',
  philippines: 'PH',
}

export function countryToCode(country?: string | null): string | null {
  if (!country) return null
  const key = country.trim().toLowerCase()
  if (!key) return null
  if (ALIASES[key]) return ALIASES[key]
  if (/^[a-z]{2}$/.test(key)) return key.toUpperCase()
  return null
}

function flagEmoji(code: string): string {
  return code
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
}

export function countryFlag(country?: string | null): { emoji: string; label: string } | null {
  const code = countryToCode(country)
  if (!code) return null
  return { emoji: flagEmoji(code), label: (country ?? '').trim() }
}
